import { useCallback } from 'react';

import type { ValidationError } from '../../utils/validations';

interface UseFieldValidationProps {
  errors: ValidationError[];
  touchedFields: Set<string>;
}

/**
 * Common hook for field validation helpers
 * Provides methods to check field errors and validity
 */
export const useFieldValidation = ({ errors, touchedFields }: UseFieldValidationProps) => {
  const getFieldError = useCallback(
    (field: string): string | undefined => {
      // Only show error if field has been touched
      if (!touchedFields.has(field)) return undefined;
      const error = errors.find((e) => e.field === field);
      return error?.message;
    },
    [errors, touchedFields]
  );

  const isFieldValid = useCallback(
    (field: string): boolean => {
      if (!touchedFields.has(field)) return true;
      return !errors.some((e) => e.field === field);
    },
    [errors, touchedFields]
  );

  return {
    getFieldError,
    isFieldValid,
  };
};
